export const REQUEST_PAYMENT_TOKEN = 'app/actions/REQUEST_PAYMENT_TOKEN';
export const REQUEST_PAYMENT_TOKEN_SUCCESS = 'app/actions/REQUEST_PAYMENT_TOKEN_SUCCESS';
export const PAYMENT = 'PAYMENT';
